import * as React from 'react'
import VehicleActivitiesActionBar from '../shared/actionBars/VehicleActivitiesActionBar'
import Yearly from '../tabs/activities/views/Yearly'

export const VehicleCalendarPage = () => (
  <div className="tw-flex tw-h-full tw-flex-col">
    <div className="tw-relative tw-bg-content-primary">
      <VehicleActivitiesActionBar />
    </div>
    <Yearly />
  </div>
)
